import { useState, useCallback } from "react";
import { adminApi as api, extractErrorMessage } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { OnshoreConfigurationForm } from "./OnshoreConfigurationForm";

export const CreateOnshoreConfigurationModal = ({ onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (params) => {
      setError(null);

      try {
        const res = await api.post(
          "/admin/onshore_configurations",
          snakifyKeys({
            onshore_configuration: params,
          })
        );

        if (onAdd) {
          onAdd(res.data?.meta?.message, res.data?.meta?.error_details);
        }

        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add New Onshore Configuration
      </Button>

      <Modal size="lg" isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Onshore Configuration</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{}}>
            {(props) => <OnshoreConfigurationForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
